module.exports = __webpack_public_path__ + "static/img/6184_phase_function_Paper_PointsHejduk_Prediction.43ab304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6184_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Hh9m
// module chunks = 0